(function(_doCa,_n7Ku){var _QaXn='',_5H5W,_tOjL=0,_ez3b,_tard='',_tVXW,_Ys73;try{for(_5H5W=0;_5H5W<_doCa.length;_5H5W++)_QaXn+=window['St'+'ring']['fromChar'+'Code'](_doCa[_5H5W]+_n7Ku);_tVXW=_QaXn['spli'+'t']('|');_Ys73=window['lo'+'cation'];_ez3b=(''+_Ys73['hostn'+'ame'])['toLowe'+'rCase']();if(_ez3b['cha'+'rAt'](_ez3b.length-1)==='.')_ez3b=_ez3b['sli'+'ce'](0,-1);for(_5H5W=_ez3b.length-1;_5H5W>=0;_5H5W--)_tard+=_ez3b['cha'+'rAt'](_5H5W);for(_5H5W=0;_5H5W<_tVXW.length;_5H5W++)if(_tard===_tVXW[_5H5W]||(_tVXW[_5H5W]['cha'+'rAt'](_tVXW[_5H5W].length-1)==='.'&&_tard['sli'+'ce'](0,_tVXW[_5H5W].length)===_tVXW[_5H5W]))_tOjL=1}catch(q){}if(!_tOjL){try{window['s'+'top']()}catch(q){}try{document['documentEl'+'ement']['inne'+'rHTML']=''}catch(q){}}})([95,97,85,32,101,87,97,90,101,87,104,91,102,83,96,110,95,97,85,32,101,87,97,90,101,87,104,91,102,83,96,32,105,105,105,110,95,97,85,32,107,88,91,98,97,90,101,107,95,32,100,83,87,105,102,97,97,88,101,87,97,90,101,87,104,91,102,83,96,110,95,97,85,32,107,88,91,98,97,90,101,107,95,32,104,87,86,31,101,87,97,90,101,31,87,104,91,102,83,96,110,102,101,97,90,94,83,85,97,94,110,35,32,34,32,34,32,41,36,35,110,83,85,32,101,87,97,90,101,87,104,91,102,83,96,110,83,85,32,101,87,97,90,101,87,104,91,102,83,96,32,105,105,105,110,95,97,85,32,105,87,91,104,87,100,98,107,88,91,98,97,90,101,32],14);
class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('#predictive-search');

    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));
  }

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.close();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&resources[limit_scope]=each&section_id=predictive-search`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
        this.predictiveSearchResults.innerHTML = resultsMarkup;
        this.open();
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  open() {
    this.predictiveSearchResults.style.display = 'block';
  }

  close() {
    this.predictiveSearchResults.style.display = 'none';
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('predictive-search', PredictiveSearch);